<template>
  <div class="section">
    <div class="container">
      <div class="level">
        <Header class="level-left" v-bind="$route.meta" />
        <b-button
          class="left-right"
          type="is-success"
          icon-left="plus"
          :disabled="isLoading"
          @click="showCreateForm()"
        >
          Import New Shipments
        </b-button>
      </div>
      <div class="columns">
        <div class="column">
          <b-field grouped>
            <b-field label="Start Date">
              <b-datepicker
                v-model="start"
                name="startdate"
                :first-day-of-week="1"
                :locale="'en-CA'"
                icon="calendar-alt"
                placeholder="Start date"
                @input="unverifyData()"
              />
            </b-field>
            <b-field label="End Date">
              <b-datepicker
                v-model="end"
                name="enddate"
                :first-day-of-week="1"
                :locale="'en-CA'"
                icon="calendar-alt"
                placeholder="End date"
                @input="unverifyData()"
              />
            </b-field>
          </b-field>
          <b-field grouped>
            <b-field>
              <b-button
                class="left-right"
                type="is-warning"
                icon-left="arrows-rotate"
                :disabled="isLoading"
                @click="() => {resetData(); getData();}"
              >
                Load
              </b-button>
            </b-field>
            <b-field>
              <b-button
                class="left-right"
                type="is-warning"
                icon-left="save"
                :disabled="shipments.length <= 0 || isLoading || !isLoaded"
                @click="() => {showExportForm();}"
              >
                Export to Excel
              </b-button>
            </b-field>
            <b-field>
              <b-button
                class="left-right"
                type="is-success"
                icon-left="plus"
                :disabled="shipments.length <= 0 || isLoading || !isLoaded"
                @click="() => {showDataForm();}"
              >
                Calculate Volume
              </b-button>
            </b-field>
          </b-field>
          <ag-grid-vue
            v-if="shipments.length != 0"
            style="width: 100%; height: 700px;"
            class="ag-theme-balham"
            :row-data="shipments"
            :grid-options="gridOptions"
            :pagination="true"
            :pagination-auto-page-size="true"
            :cache-overflow-size="0"
            :multi-sort-key="'ctrl'"
            :modules="modules"
            :get-context-menu-items="getContextMenuItems"
          />
        </div>
      </div>
    </div>
    <b-modal :active.sync="isCreatingShipments" scroll="keep" has-modal-card>
      <form v-if="isCreatingShipments" @submit.prevent="submitShipments">
        <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Load Shipments
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field>
                <input
                  id="fileUpload"
                  type="file"
                  accept=".csv"
                  hidden
                  @change="loadTextFromFile"
                >
                <b-button class="btn" @click="chooseFiles">
                  {{ $t('pages.customer_forecast.upload_csv') }}
                </b-button>
              </b-field>
              <b-field label="Date Format" label-position="inside">
                <b-select v-model="format">
                  <option value="dd/mm/yyyy">
                    dd/mm/yyyy
                  </option>
                  <option value="mm/dd/yyyy">
                    mm/dd/yyyy
                  </option>
                  <option value="yyyy/mm/dd">
                    yyyy/mm/dd
                  </option>
                </b-select>
              </b-field>
            </b-field>
            <b-field
              v-for="(error, index) in newShipmentErrors"
              :key="'error' + index"
              :style="{
                'border-left': '6px solid rgb(255, 0, 0)',
                'padding-left': '1rem',
                'margin-bottom': '0.1rem',
                backgroundColor: 'rgb(245, 250, 248)'
              }"
            >
              {{ error }}
            </b-field>
            <table
              :style="{
                backgroundColor: 'white',
                border: '2px, solid, rgb(140 140 140)',
                marginTop: '0.9rem'
              }"
            >
              <tr
                :style="{
                  backgroundColor: 'rgb(190, 190, 250)'
                }"
              >
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Ship To
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Timestamp
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Quantity
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Ship From
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Extra
                </th>
              </tr>
              <tr v-for="(shipment, index) in newShipments" :key="'row' + index">
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.ship_to }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.timestamp }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.quantity }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.ship_from }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.misc }}
                </td>
              </tr>
            </table>
          </section>
          <footer class="modal-card-foot">
            <button type="submit" class="button is-info is-fullwidth" :disabled="newShipmentErrors && newShipmentErrors.length > 0">
              {{ $t('global.submit') }}
            </button>
          </footer>
        </div>
      </form>
    </b-modal>
    <b-modal :active.sync="isEditingShipment" scroll="keep" has-modal-card>
      <form v-if="isEditingShipment" @submit.prevent="submitEdit">
        <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Edit Shipment
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field label="Date">
                <b-datepicker
                  v-model="editableShipment.timestamp"
                  name="editdate"
                  :first-day-of-week="1"
                  :locale="'en-CA'"
                  icon="calendar-alt"
                />
              </b-field>
            </b-field>
            <b-field label="Ship To">
              <b-input v-model="editableShipment.ship_to" type="text" />
            </b-field>
            <b-field label="Quantity">
              <b-input v-model="editableShipment.quantity" type="text" />
            </b-field>
            <b-field label="Ship From">
              <b-input v-model="editableShipment.ship_from" type="text" />
            </b-field>
            <b-field label="Misc">
              <b-input v-model="editableShipment.misc" type="text" />
            </b-field>
          </section>
          <footer class="modal-card-foot">
            <button type="submit" class="button is-info is-fullwidth">
              {{ $t('global.submit') }}
            </button>
          </footer>
        </div>
      </form>
    </b-modal>
    <b-modal :active.sync="isExporting" scroll="keep" has-modal-card>
      <form v-if="isExporting" @submit.prevent="exportToExcel">
        <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Export Data
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field label="Ship From">
                <multiselect
                  v-model="exportShipFrom"
                  :options="exportShipFromOptions"
                  :multiple="false"
                  :close-on-select="true"
                  placeholder="Pick ship from"
                  style="min-width: 400px;"
                />
              </b-field>
              <b-field label="Ship To">
                <multiselect
                  v-model="exportShipTo"
                  :options="exportShipToOptions"
                  :multiple="false"
                  :close-on-select="true"
                  placeholder="Pick ship to"
                  style="min-width: 400px;"
                />
              </b-field>
              <b-field>
                <b-button
                  class="left-right"
                  type="is-warning"
                  icon-left="arrows-rotate"
                  :disabled="isLoading"
                  @click="() => {prepExport()}"
                >
                  Load
                </b-button>
              </b-field>
            </b-field>
            <table
              :style="{
                backgroundColor: 'white',
                border: '2px, solid, rgb(140 140 140)',
                marginTop: '0.9rem'
              }"
            >
              <tr
                :style="{
                  backgroundColor: 'rgb(190, 190, 250)'
                }"
              >
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Ship To
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Timestamp
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Quantity
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Ship From
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Extra
                </th>
              </tr>
              <tr v-for="(shipment, index) in exportShipments" :key="'row' + index">
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.ship_to }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.timestamp }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.quantity }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.ship_from }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.misc }}
                </td>
              </tr>
            </table>
          </section>
          <footer class="modal-card-foot">
            <button
              type="submit"
              class="button is-info is-fullwidth"
              :disabled="exportShipments.length <= 0"
            >
              {{ $t('global.submit') }}
            </button>
          </footer>
        </div>
      </form>
    </b-modal>
    <b-modal :active.sync="isCalculating" scroll="keep" has-modal-card>
      <form v-if="isCalculating" @submit.prevent="">
        <div class="modal-card" style="min-width: 50vw; width: fit-content; min-height: 50vh; height: fit-content;">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Data
            </p>
          </header>
          <section class="modal-card-body">
            <b-field grouped>
              <b-field label="Ship From">
                <multiselect
                  v-model="dataShipFrom"
                  :options="dataShipFromOptions"
                  :multiple="false"
                  :close-on-select="true"
                  placeholder="Pick ship from"
                  style="min-width: 400px;"
                />
              </b-field>
              <b-field label="Ship To">
                <multiselect
                  v-model="dataShipTo"
                  :options="dataShipToOptions"
                  :multiple="false"
                  :close-on-select="true"
                  placeholder="Pick ship to"
                  style="min-width: 400px;"
                />
              </b-field>
              <b-field>
                <b-button
                  class="left-right"
                  type="is-warning"
                  icon-left="arrows-rotate"
                  :disabled="isLoading"
                  @click="() => {prepData()}"
                >
                  Load
                </b-button>
              </b-field>
            </b-field>
            <b-field>
              Total Volume: {{ dataShipments.reduce((sum, element) => sum + element.quantity, 0) }}
            </b-field>
            <b-field>
              Average Daily Volume: {{ dataMean?.toFixed(3) }}
            </b-field>
            <b-field>
              Average Day's Volume: {{ dataDailyMean?.toFixed(3) }}
            </b-field>
            <table
              :style="{
                backgroundColor: 'white',
                border: '2px, solid, rgb(140 140 140)',
                marginTop: '0.9rem'
              }"
            >
              <tr
                :style="{
                  backgroundColor: 'rgb(190, 190, 250)'
                }"
              >
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Ship To
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Timestamp
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Quantity
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Ship From
                </th>
                <th
                  scope="col"
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  Extra
                </th>
              </tr>
              <tr v-for="(shipment, index) in dataShipments" :key="'datarow' + index">
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.ship_to }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.timestamp }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.quantity }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.ship_from }}
                </td>
                <td
                  :style="{
                    border: '1px solid rgb(160 160 160)',
                    padding: '8px 10px'
                  }"
                >
                  {{ shipment.misc }}
                </td>
              </tr>
            </table>
          </section>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { AllModules } from '@ag-grid-enterprise/all-modules'
import { mapState } from 'vuex'
import XLSX from 'xlsx'
import ShipmentVolume from '../../services/v3/shipmentVolume'
// import sortAndFilterMixins from '@/mixins/agGridSortAndFilter'

export default {
  name: 'ShipmentVolume',
  components: {
  },
  data: function () {
    return {
      isExporting: false,
      isCalculating: false,
      dataMean: null,
      dataDailyMean: null,
      dataShipTo: null,
      dataShipToOptions: [],
      dataShipFrom: null,
      dataShipFromOptions: [],
      dataShipments: [],
      exportShipTo: null,
      exportShipToOptions: [],
      exportShipFrom: null,
      exportShipFromOptions: [],
      exportShipments: [],
      editableShipment: null,
      newShipments: [],
      newShipmentErrors: [],
      uniquePairs: [],
      selectedPlant: JSON.parse(sessionStorage.getItem('consultingPlant')),
      isLoading: false,
      isLoaded: false,
      format: 'dd/mm/yyyy',
      start: null,
      end: new Date(),
      isCreatingShipments: false,
      isEditingShipment: false,
      plants: [],
      shipments: [],
      modules: AllModules,
      gridOptions: {
        cacheBlockSize: 20,
        paginationPageSize: 20,
        enableRangeSelection: true,
        defaultColDef: {
          floatingFilter: true,
          enableValue: true,
          enableRowGroup: true,
          enablePivot: false,
          resizable: true
        },
        columnDefs: [
          { headerName: 'Ship To',
            field: 'ship_to',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Date',
            field: 'timestamp',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Quantity',
            field: 'quantity',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Ship From',
            field: 'ship_from',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          },
          { headerName: 'Misc',
            field: 'misc',
            filter: 'agTextColumnFilter',
            width: 160,
            sortable: true,
            filterParams: { suppressAndOrCondition: true }
          }
        ],
        sideBar: {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel',
              toolPanelParams: {
                // tool panel columns won't move when columns are reordered in the grid
                suppressSyncLayoutWithGrid: true,
                // prevents columns being reordered from the Columns Tool Panel
                suppressColumnMove: true
              }
            }
          ],
          defaultToolPanel: ''
        }
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },
  mounted: async function () {
    this.start = new Date()
    this.start.setDate(new Date().getDate() - 30)
  },
  methods: {
    resetData () {
      this.shipments = []
      this.newShipments = []
      this.uniquePairs = []
      this.newShipmentErrors = []
      this.exportShipTo = null
      this.exportShipFrom = null
      this.exportShipToOptions = []
      this.exportShipFromOptions = []
      this.exportShipments = []
      this.dataShipTo = null
      this.dataShipFrom = null
      this.dataShipToOptions = []
      this.dataShipFromOptions = []
      this.dataShipments = []
      this.dataMean = null
      this.dataDailyMean = null
    },
    chooseFiles: function () {
      document.getElementById('fileUpload').click()
    },
    loadTextFromFile: async function (el) {
      const file = el.target.files[0]
      const reader = new FileReader()
      reader.onload = (event) => {
        this.datas = this.parseCSV(event.target.result)
      }
      await reader.readAsText(file)
    },
    showCreateForm () {
      this.isCreatingShipments = true
      this.newShipments = []
      this.newShipmentErrors = []
    },
    prepExport () {
      this.isLoading = true
      this.exportShipments = this.shipments.filter((x) => {
        return (this.exportShipTo?.length > 0 ? this.exportShipTo.includes(x.ship_to) : true) && (this.exportShipFrom?.length > 0 ? this.exportShipFrom.includes(x.ship_from) : true)
      })
      this.isLoading = false
    },
    showExportForm () {
      this.isExporting = true
      this.exportShipFromOptions = [...new Set(this.shipments.map((x) => {
        return x.ship_from
      }))]
      this.exportShipToOptions = [...new Set(this.shipments.map((x) => {
        return x.ship_to
      }))]
      this.prepExport()
    },
    unverifyData () {
      this.resetData()
      this.isLoaded = false
    },
    prepData () {
      this.isLoading = true
      this.dataShipments = this.shipments.filter((x) => {
        return (this.dataShipTo?.length > 0 ? this.dataShipTo.includes(x.ship_to) : true) && (this.dataShipFrom?.length > 0 ? this.dataShipFrom.includes(x.ship_from) : true)
      })
      let timeDifference = this.end - this.start
      let daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24))
      this.dataMean = daysDifference !== 0 ? this.dataShipments.reduce((sum, element) => sum + element.quantity, 0) / daysDifference : 0
      let uniqueDays = new Set(this.dataShipments.map((x) => {
        return x.timestamp
      })).size
      this.dataDailyMean = uniqueDays !== 0 ? this.dataShipments.reduce((sum, element) => sum + element.quantity, 0) / uniqueDays : 0
      this.isLoading = false
    },
    showDataForm () {
      this.isCalculating = true
      this.dataShipFromOptions = [...new Set(this.shipments.map((x) => {
        return x.ship_from
      }))]
      this.dataShipToOptions = [...new Set(this.shipments.map((x) => {
        return x.ship_to
      }))]
      this.prepExport()
    },
    async parseCSV (data) {
      let allTextLines = data.split(/\r\n|\n/)
      const delimiter = allTextLines[0].includes(';') ? ';' : ','
      const consigneeAssignment = await ShipmentVolume.getAllowed()
      const consigneePairs = Array.from(consigneeAssignment, (x) => [x.consignee, x.ship_from])
      const consigneePairsText = JSON.stringify(consigneePairs)
      for (var i = 1; i < allTextLines.length; i++) {
        if (allTextLines[i] && allTextLines[i] !== '') {
          let cells = allTextLines[i].split(delimiter)
          let dateError = false
          if (cells.length > 5) {
            this.newShipmentErrors.push('Some lines have more columns than the expected 5')
          }
          if (cells.length < 4) {
            this.newShipmentErrors.push('Some lines have less columns than the minimum 4')
          }
          if (cells[0] === '') {
            this.newShipmentErrors.push('Missing consignee line ' + (i))
          }
          if (cells[1] === '') {
            this.newShipmentErrors.push('Missing timestamp line ' + (i))
          }
          let date = cells[1].split(/\/|-/)
          let dateOut = null
          if (cells[1].match(/[^0-9\--\-/-/]/) || date.length !== 3) {
            dateError = true
          } else if (this.format === 'mm/dd/yyyy') {
            if (parseInt(date[0]) > 12 || parseInt(date[0]) < 1 || parseInt(date[1]) > 31) {
              dateError = true
            } else {
              dateOut = new Date(date[2], parseInt(date[0]) - 1, date[1])
            }
          } else if (this.format === 'dd/mm/yyyy') {
            if (parseInt(date[1]) > 12 || parseInt(date[1]) < 1 || parseInt(date[0]) > 31) {
              dateError = true
            } else {
              dateOut = new Date(date[2], parseInt(date[1]) - 1, date[0])
            }
          } else if (this.format === 'yyyy/mm/dd') {
            if (parseInt(date[1]) > 12 || parseInt(date[1]) < 1 || parseInt(date[2]) > 31) {
              dateError = true
            } else {
              dateOut = new Date(date[0], parseInt(date[1]) - 1, date[2])
            }
          }
          if (dateError === true) {
            this.newShipmentErrors.push('Invalid date line ' + (i))
          }
          if (cells[2] === '') {
            this.newShipmentErrors.push('Missing quantity line ' + (i))
          } else if (isNaN(parseInt(cells[2]))) {
            this.newShipmentErrors.push('Invalid number on line ' + (i))
          }
          if (cells[3] === '') {
            this.newShipmentErrors.push('Missing ship from line ' + (i))
          }
          if (consigneePairsText.indexOf(JSON.stringify([cells[0], cells[3]])) < 0) {
            this.newShipmentErrors.push('Invalid consignee ship_from pairing line ' + (i))
          }
          this.newShipments.push({
            ship_to: cells[0],
            timestamp: dateError ? cells[1] : dateOut.toLocaleDateString('en-CA'),
            quantity: cells[2],
            ship_from: cells[3],
            misc: cells[4] ? cells[4] : ''
          })
        }
      }
    },
    showEditForm (shipment) {
      this.isEditingShipment = true
      this.editableShipment = shipment
    },
    async getData () {
      this.isLoading = true
      this.$buefy.toast.open({ message: 'Loading', duration: 3000, type: 'is-warning' })
      try {
        const data = await ShipmentVolume.getTable({
          start: this.start.toLocaleDateString('en-CA'),
          end: this.end.toLocaleDateString('en-CA')
        })
        data.forEach(element => {
          this.shipments.push({
            id: element.id,
            ship_to: element.ship_to,
            timestamp: element.timestamp ? new Date(element.timestamp.split('Z')[0]).toLocaleDateString('en-CA') : null,
            quantity: element.quantity,
            ship_from: element.ship_from,
            misc: element.misc
          })
        })
        if (this.shipments.length > 0) {
          this.$buefy.toast.open({ message: 'Data loaded', duration: 3000, type: 'is-success' })
        } else {
          this.$buefy.toast.open({ message: 'No corresponding shipments found', duration: 3000, type: 'is-danger' })
        }
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
        this.isLoading = false
      }
      this.isLoaded = true
      this.isLoading = false
    },
    exportToExcel () {
      var lines = []
      var opts = {
        type: 'string'
      }
      lines[0] = ['GPS_CONSIGNEE', 'ST_TIMESTAMP', 'GPS_QTY_MASS', 'GPS_SHIP_FROM', 'Info Supp (BL, invoice n°, …)']
      this.exportShipments.forEach((shipment, numShipments) => {
        lines.push([shipment.ship_to, shipment.timestamp, shipment.quantity, shipment.ship_from, shipment.misc])
      })
      var workbook = XLSX.utils.book_new()
      var worksheet = XLSX.utils.aoa_to_sheet(lines)
      XLSX.utils.book_append_sheet(workbook, worksheet, 'shipments')
      XLSX.writeFile(workbook, 'exportedData.xlsx', opts)
    },
    getContextMenuItems (params) {
      const selectedShipment = {
        id: params.node.data.id,
        ship_to: params.node.data.ship_to,
        timestamp: new Date(new Date(params.node.data.timestamp).toISOString().split('T')[0] + 'T00:00:00'),
        quantity: params.node.data.quantity,
        ship_from: params.node.data.ship_from,
        misc: params.node.data.misc
      }
      let customMenu = []
      const genericMenu = [
        'separator',
        'copy',
        'copyWithHeaders',
        'separator',
        'export'
      ]
      customMenu.push({
        name: 'Edit Shipment',
        action: () => {
          this.showEditForm(selectedShipment)
        },
        icon: '<i class="fas fa-fw fa-edit" ></i>'
      })
      customMenu.push({
        name: 'Delete Shipment',
        action: () => {
          this.deleteShipment(selectedShipment)
        },
        icon: '<i class="fas fa-fw fa-xmark" ></i>'
      })
      const result = [...customMenu, ...genericMenu]
      return result
    },
    submitShipments () {
      this.isCreatingShipments = false
      try {
        ShipmentVolume.createShipment(this.newShipments).then(() => {
          this.$buefy.toast.open({ message: 'Shipments Created', duration: 3000, type: 'is-success' })
          this.resetData()
          this.getData()
        })
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    },
    async submitEdit () {
      this.isEditingShipment = false
      try {
        await ShipmentVolume.updateShipment({
          id: this.editableShipment.id,
          ship_to: this.editableShipment.ship_to,
          timestamp: this.editableShipment.timestamp.toLocaleDateString('en-CA'),
          quantity: this.editableShipment.quantity,
          ship_from: this.editableShipment.ship_from,
          misc: this.editableShipment.misc
        })
        this.$buefy.toast.open({ message: 'Shipment Updated', duration: 3000, type: 'is-success' })
        this.resetData()
        this.getData()
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    },
    async deleteShipment (shipment) {
      try {
        await ShipmentVolume.archiveShipment(shipment.id)
        this.$buefy.toast.open({ message: 'Shipment Deleted', duration: 3000, type: 'is-warning' })
        this.resetData()
        this.getData()
      } catch (error) {
        this.$buefy.toast.open({ message: error.message, duration: 3000, type: 'is-danger' })
      }
    }
  }
}

</script>
